export const getDefaultState = () => ({
    id: localStorage.getItem('provider'),
    provider: null,
    // Additional provider objects - future
    providers: [],
    // Patients from all Providers
    providerPatients: [],
    loadedAllProviders: false,
    loadedAllProviderPatients: false,
    loadedAllProviderEvents: false,
    assistant: {},
    filters: {},
    surveyState: {},
    surveyRecord: {},
    patientAnalytics: {},
    timezone: false,

    // Loaded profiles
    profile: [],
    event: [],
    // Map of event to provider used for imports
    scheduledEventMap: {},
    schedule: [],
    message: [],
    tickets: [],
    ticketsConfig: [],
    allEvents: false,
    allSchedules: false,
    allMessages: false,
    allTickets: false,
    allPatientCount: null,
    messagingPatientBulk: false,
    notifyingPatient: false,

    // Mapping to patient auth objects
    patient: {},
    patientNextQuery: null,
    allPatients: false,

    // Provider records mapping from patient ID -> array of records
    record: {
        event: {},
        schedule: {},
        message: {},
        questionnaire: {},
        // Whether a patient's complete record has been loaded
        complete: {},
        // Tickets raised by patients to there doctors
        ticket: {},
        // Files uploaded for patient
        file: {},
        // Record uploaded for patients
        record: {},
        // Surveys answered for patient
        survey: {},
        // Charts of ctc
        charts: {}
    },
    loadingRecords: false,

    // Loading the provider object
    loading: true,
    loadingEvents: false,
    loadingTickets: false,
    loadingSchedules: false,
    scheduleNextQuery: null,

    // Currently enrolling patients/inviting assistant
    creatingPatient: false,
    invitingAssistant: false,

    // Currently retrieving patients
    loadingPatients: false,
    loadingPatient: {},
    updatingPatient: {},
    nextPatients: {},
    overview: {},
    siteOverview: {},
    loadedPatient: {},
    schedulingPatient: {},
    messagingPatient: {},
    ticketingPatient: {},
    loadingLineup: false,

    loadingAllProviderPatients: false,
    loadingAllProviderLinedownPatients: false,
    loadedAllProviderLinedownPatients: false,


    // Currently archiving a patient
    archivingPatient: false,

    // Filter creation/testing
    filterArg: {},
    editingFilter: false,
    testingFilter: false,

    pushIntegration: [],

    remindingPatient: {},

    // Date filter
    filterTimestamp: {},
    fileUploading: false,
    fileUploadingError: false,
    fileUploadSuccess: false,
    fileUploadKey: null,
    importErrors: [],
    importMapping: {},
    ignoringErrorIds: [],
    loadingImportErrors: true,
    resolvedErrorCount: 0,
    
    // Tag to color mapping
    patientTagToColorMapping: []
})

const state = getDefaultState()

export default state
